import { useEffect, useRef } from 'react'
import type { Locale } from '../data/schema'

interface LanguageGateProps {
  onSelect: (locale: Locale) => void
}

export function LanguageGate({ onSelect }: LanguageGateProps) {
  const englishButton = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    englishButton.current?.focus()
  }, [])

  return (
    <main className="language-gate" data-testid="language-gate" aria-labelledby="language-gate-title">
      <div className="language-gate-atmosphere" aria-hidden="true"><i /><i /><i /></div>
      <section className="language-gate-panel">
        <div className="language-brand" aria-label="MythWeave">
          <span className="brand-mark"><span>Μ</span></span>
          <span className="brand-words"><strong>MythWeave</strong><small>THE HELLENIC ATLAS</small></span>
        </div>
        <span className="eyebrow" lang="en">Welcome · 歡迎</span>
        <h1 id="language-gate-title">
          <span lang="en">Enter MythWeave</span>
          <span lang="zh-Hant">進入 MythWeave</span>
        </h1>
        <p>
          <span lang="en">Choose a language below to continue. This screen will not advance automatically.</span>
          <span lang="zh-Hant">請選擇語言。完成選擇後才會進入 MythWeave。</span>
        </p>
        <div className="language-options">
          <button ref={englishButton} type="button" lang="en" onClick={() => onSelect('en')}>
            <span className="language-code">EN</span>
            <span><strong>English</strong><small>Enter the atlas in English</small></span>
            <span aria-hidden="true">→</span>
          </button>
          <button type="button" lang="zh-Hant" onClick={() => onSelect('zh-Hant')}>
            <span className="language-code">繁</span>
            <span><strong>繁體中文</strong><small>以繁體中文進入神話地圖</small></span>
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </section>
    </main>
  )
}
